import CalendarView from './components/CalendarView';
import * as styles from './components/styles.scss';
import { CalendarPayload, CalendarViewType } from './schema';
import { getAssetResizeConfiguration } from './utils/getAssetResizeConfiguration';
import getDisplayNameForCalendar from './utils/getDisplayNameForCalendar';
import { logCalendarAssetPayload } from './utils/loggingUtils';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { AssetAriaLabel, registerAsset, DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import {
    assetErrorCalendar,
    calendarAssetName,
    calendarAssetTooltip,
} from './calendar.locstring.json';

const CALENDAR_TYPE = 'calendar';

export default registerAsset<CalendarPayload>({
    type: CALENDAR_TYPE,
    iconName: ControlIcons.Calendar,
    getToolName: () => loc(calendarAssetName),
    getTooltip: () => loc(calendarAssetTooltip),
    getErrorMessage: () => loc(assetErrorCalendar),
    CanvasView: CalendarView,
    viewStyle: styles.calendarView,
    createEmptyAsset: () => ({
        type: CALENDAR_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: {
            calendarIds: [],
            viewType: CalendarViewType.Agenda,
            connectedAccountCalendarIds: [],
        },
    }),
    unsupportedDefaultCommands: [DefaultCommand.Color, DefaultCommand.DueDate],
    getTitleString: () => '', // TODO VSO 93135: Allow disabling turning an asset into a task
    getSearchString: getCalendarName,
    getAriaLabel: getCalendarAriaLabelName,
    assetResizeConfiguration: getAssetResizeConfiguration,
    onProjectOpened: logCalendarAssetPayload,
});

function getCalendarName(payload: CalendarPayload) {
    return payload.title || payload.calendarIds.map(id => getDisplayNameForCalendar(id)).join(' ');
}

function getCalendarAriaLabelName(payload: CalendarPayload) {
    return loc(AssetAriaLabel.assetAriaLabel, loc(calendarAssetName), getCalendarName(payload));
}
